'use strict';

angular.module('atex.dam').controller('DamBrowserButtonController', [ '$scope', function($scope) {
  $scope.currentValue = undefined;

  $scope.browse = function() {
    var inputFile;
    if ($scope.allowMultiple) {
      inputFile = $('<input/>').attr('type', 'file').attr('class', 'file-browse').attr('multiple', 'multiple');
    } else {
      inputFile = $('<input/>').attr('type', 'file').attr('class', 'file-browse');
    }
    inputFile.bind('change', function(event) {
      var selectedFiles = event.originalEvent.target.files;
      var fileList = Array.from(selectedFiles);
      if ($scope.selectCallBack) {
        $scope.selectCallBack({
          'files' : fileList
        });
      }
      inputFile.remove();
    });
    inputFile.click();
  };
  
} ]);

angular.module('atex.dam').directive('damBrowserButton', function() {
  return {
    restrict : 'E',

    templateUrl : 'js/dam/widgets/dam-browser-button/dam-browser-button.html',

    replace : true,

    scope : {
      label : '@',
      allowMultiple : '=',
      selectCallBack : '&'
    },

    controller : 'DamBrowserButtonController',

    link : function(scope, element, attrs) {
      
    }
  };
});
